import { createSlice } from "@reduxjs/toolkit";

const initialListingsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  meta: {},
  entities: null,
  listingForEdit: undefined,
  lastError: null,
  queryParams: {},
  filters: {},
  reset: 0,
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const agentFollowupsSlice = createSlice({
  name: "agentFollowupsSlice",
  initialState: { ...initialListingsState },
  extraReducers: (builder) => {
    builder.addCase("[Auth] Logout Action", (state, action) => {
      return { ...initialListingsState };
    });
  },
  reducers: {
    resetPage: (state, action) => {
      state.reset++;
    },

    reset: (state, action) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.totalCount = 0;
      state.entities = null;
      state.listingForEdit = undefined;
      state.lastError = null;
      state.queryParams = {};
      state.filters = {};
    },

    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    listingFetched: (state, action) => {
      state.actionsLoading = false;
      state.listingForEdit = action.payload.listingForEdit;
      state.error = null;
    },

    listingsFetched: (state, action) => {
      var { meta, totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.meta = meta;
      state.entities = entities;
      state.totalCount = totalCount;

      if (action.payload["queryParams"]) {
        state.queryParams = action.payload["queryParams"];
      }
    },

    setFilters: (state, action) => {
      state.listLoading = false;
      if (action.payload["filters"]) {
        state.filters = { ...action.payload["filters"] };
      }
    },
  },
});
